import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { validationSchema } from "../../../service/validation/vehicle";
import Input from "../../../components/FormInputs";
import FormTitle from "../../../components/FormTitle";
import AdminContainer from "../../Admin";
import Header from '../../../components/Header';
import { vehicles } from '../../../common/svg';
import { VehicleTabs } from "../../../common/tabs";
import { VehicleFormData } from "../../../service/interfaces/Forms";
import DatePicker from "../../../components/Datepicker";
import { ApiService } from "../../../service/api.service";
import PhoneInput from "../../../components/phoneinput";
import { useNavigate, useParams } from "react-router-dom";
import { ECHO_URL, MASTER_URL } from "../../../common/common";
import CustomDropDown from "../../../components/Dropdown/CustomDropDown";
import CustomTabs from "../../../components/Tab";
import OwnerDetails from "./SubTab/ownerDetails";
import Insurance from "./SubTab/Insurance";
import AddressDetails from "./SubTab/AddressDetails";
const Managevehicle = () => {
  const apiService = new ApiService();
  const { id } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<string>("Owner Details");
  const [insuranceExpiryDateValue, setInsuranceExpiryDateValue] = useState<any>(null);
  const [companyData, setCompanyData] = useState<any>([]);
  const [selectedCompany, setSelectedCompany] = useState<string | number>("");
  const [vehicle, setVehicle] = useState<any>([]);
  const [useSameContact, setUseSameContact] = useState<boolean>(false);
  const [VehicleFormData, setVehicleFormData] = React.useState<any | null>(null);


  const {
    register,
    handleSubmit,
    formState: { errors },
    trigger,
    setValue,
    control,
    reset, watch
  } = useForm<VehicleFormData>({
    resolver: yupResolver(validationSchema),
  });

  const getData = async () => {
    if (!id) return;
    try {
      const response: any = await apiService.getApi(`${MASTER_URL}/vehicle/get-one-route?vehicleId=${id}`)
      if (response.status === "200") {
        const data = response.body

        // Helper function to check if value is valid (not null, undefined, empty, or "NA")
        const isValidValue = (value: any) => {
          return value && value !== "" && value !== "NA" && value !== "na" && value !== null && value !== undefined;
        }

        // Set vehicle details - only if data exists, no fallback values
        if (isValidValue(data.vehicleMake)) setValue("vehicleDetails.VehicleName", data.vehicleMake)
        if (isValidValue(data.vehicleMake)) setValue("vehicleDetails.brandName", data.vehicleMake)
        if (isValidValue(data.vehicleModel)) setValue("vehicleDetails.model", data.vehicleModel)
        if (isValidValue(data.vehicleYear)) setValue("vehicleDetails.manufacturerYear", data.vehicleYear)
        if (isValidValue(data.trailerSize)) setValue("vehicleDetails.trailerSize", data.trailerSize)
        if (isValidValue(data.chassisNumber)) setValue("vehicleDetails.chassisNumber", data.chassisNumber)
        if (isValidValue(data.engineNumber)) setValue("vehicleDetails.engineNumber", data.engineNumber)
        if (isValidValue(data.loadCapacity)) setValue("vehicleDetails.loadCapacity", data.loadCapacity)
        if (isValidValue(data.vehicleRegNo)) setValue("vehicleDetails.rcNumber", data.vehicleRegNo)
        if (isValidValue(data.vehicleType)) setValue("vehicleDetails.bodyType", data.vehicleType)
        if (isValidValue(data.tiresCount)) setValue("vehicleDetails.tiresCount", data.tiresCount)
        if (isValidValue(data.insuranceExpiryDate)) setValue("vehicleDetails.insuranceExpiryDate", data.insuranceExpiryDate)
        if (isValidValue(data.trackingUrl)) setValue("vehicleDetails.trackingUrl", data.trackingUrl)

        // Set owner details - only if data exists
        if (isValidValue(data.title)) setValue("ownerDetails.title", data.title)
        if (isValidValue(data.ownerFirstName)) setValue("ownerDetails.firstName", data.ownerFirstName)
        if (isValidValue(data.ownerLastName)) setValue("ownerDetails.lastName", data.ownerLastName)
        if (isValidValue(data.ownerName)) setValue("ownerDetails.ownerName", data.ownerName)
        if (isValidValue(data.companyName)) setValue("ownerDetails.companyName", data.companyName)
        if (isValidValue(data.ownerEmail)) setValue("ownerDetails.emailId", data.ownerEmail)
        if (isValidValue(data.phoneNumber)) setValue("ownerDetails.phoneNumber", data.phoneNumber)
        // Set countryCode - use API data if available, otherwise default to "+91"
        if (isValidValue(data.countryCode)) {
          setValue("ownerDetails.countryCode", data.countryCode)
        } else {
          setValue("ownerDetails.countryCode", "+91")
        }

        // Set insurance details - only if data exists
        if (isValidValue(data.insuranceNumber)) setValue("insuranceDetails.insuranceNumber", data.insuranceNumber)
        if (isValidValue(data.insuranceStartDate)) setValue("insuranceDetails.insuranceDate", data.insuranceStartDate)
        if (isValidValue(data.insuranceExpiryDate)) setValue("insuranceDetails.expiryDate", data.insuranceExpiryDate)

        // Set address details - only if data exists
        if (isValidValue(data.addressLine1)) setValue("addressDetails.addressLine1", data.addressLine1)
        if (isValidValue(data.addressLine2)) setValue("addressDetails.addressLine2", data.addressLine2)
        if (isValidValue(data.city)) setValue("addressDetails.city", data.city)
        if (isValidValue(data.state)) setValue("addressDetails.state", data.state)
        if (isValidValue(data.country)) setValue("addressDetails.country", data.country)
        if (isValidValue(data.pincode)) setValue("addressDetails.pincode", data.pincode)
      }
    } catch (error) {
      console.error("Error fetching vehicle data:", error);
    }
  }

  useEffect(() => {
    if (VehicleFormData) {
      reset(VehicleFormData); // Reset the form with the fetched data
    }
  }, [VehicleFormData, reset])

  const getCompanyData = async () => {
    try {
      const response: any = await apiService.getApi(`${MASTER_URL}/company/get-route`);
      if (response.status === "200") {
        console.log(response.body, "response body");
        const data = response.body;
        if (data) {
          const formattedData = data.map((item: any) => ({
            label: item.name,
            value: item.id,
          }));
          console.log(formattedData, "formatted data")
          setCompanyData(formattedData);
        }
      }
    } catch (error) {
      console.error("Error fetching master data:", error);
    }
  }
  useEffect(() => {
    getCompanyData()
  }, []);

  useEffect(() => {
    if (id) {
      getData();
    }
    // For new vehicles, ensure form starts completely empty
    else {
      reset();
      // Set default countryCode for new vehicles
      setValue("ownerDetails.countryCode", "+91");
    }
  }, [id, reset, setValue]);


  const getMasterData = async () => {
    try {
      const response: any = await apiService.getApi(`https://api.motsop.com/api/tracking/get-vechicle-route?companyId=${selectedCompany}`);
      // const response: any = await apiService.getApi(`http://192.168.0.105:6060/api/echoserver/get-vechicle-route?companyId=${selectedCompany}`);
      if (response.status === "200") {
        // console.log(response.body, "response body");
        const data = response.body;
        if (data) {
          const formattedData = data.map((item: any) => ({
            label: item.vehicle.vehicle_no,
            value: item.vehicle.id,
          }));
          console.log(formattedData, "formatted data")
          setVehicle(formattedData);
        }
      }


    } catch (error) {
      console.error("Error fetching master data:", error);
    }
  }

  useEffect(() => {
    if (selectedCompany) {
      getMasterData()
    }
  }, [selectedCompany]);

  const onSubmit = async (data: VehicleFormData) => {
    try {
      if (!data) return;

      const payload = id ? { ...data, vehicleId: id } : data;

      const response: any = id
        ? await apiService.putApi(`${MASTER_URL}/vehicle/edit-route`, payload)
        : await apiService.postApi(`${MASTER_URL}/vehicle/register-route`, payload);

      if (response?.status === "200") {
        reset();
        navigate('/vehicles');
        window.location.reload()
      } else {
        console.log(`Vehicle ${id ? "update" : "addition"} failed`);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };


  const handleCancel = () => {
    reset();
    navigate("/vehicles")
  };
  // const insuranceExpiryValue = watch("insuranceExpiryDate");
  // useEffect(() => {
  //   const subscription = watch((value) => {
  //     if (value.insuranceExpiryDate) {
  //       setInsuranceExpiryDateValue(value.insuranceExpiryDate);
  //       subscription.unsubscribe(); // 👈 Stop watching once we get it
  //     }
  //   });
  //   return () => subscription.unsubscribe(); // Cleanup on unmount
  // }, [watch]);

  return (
    <div className="">
      <div className="mb--3">
        <Header icon={vehicles} title={id ? "Edit Vehicle" : "Add New Vehicle"} showSearch={false} />
      </div>

      <AdminContainer>
        <form onSubmit={handleSubmit(onSubmit)}>
          {/* Vehicle Details */}
          <div className="bg-white p-6 rounded-[20px] font-poppins mb-6">
            <FormTitle title="Vehicle Details" />

            <div className="mt-4 grid grid-cols-4 gap-x-6 gap-y-4">
              {/* <CustomDropDown
                  register={register}
                  name="companyName"
                  errors={errors}
                  options={companyData || []}
                  label="Company Name"
                  onChange={(value: string | number) => {
                    setSelectedCompany(value.toString());
                  }}
                  // defaultValue={watch("tripDetail.managingBy")}
                /> */}

              <Input
                label="Vehicle Name"
                name="vehicleDetails.VehicleName"
                errors={errors}
                register={register}
                uppercase={true}
                placeholder="Enter vehicle name"
                type="text"
              // onBlur={() => trigger("vehicleRegNumber")}

              />
              <Input
                label="Brand Name"
                name="vehicleDetails.brandName"
                errors={errors}
                register={register}
                uppercase={true}
                placeholder="Enter brand name"
                type="text"
              // onBlur={() => trigger("vehicleRegNumber")}

              />
              <Input
                label="Model "
                name="vehicleDetails.model"
                errors={errors}
                register={register}
                uppercase={true}
                placeholder="Enter model"
                type="text"
              // onBlur={() => trigger("vehicleRegNumber")}

              />
              <Input
                label="manufacturer Year"
                name="vehicleDetails.manufacturerYear"
                errors={errors}
                register={register}
                uppercase={true}
                placeholder="Enter manufacturer year"
                type="text"
              // onBlur={() => trigger("vehicleRegNumber")}

              />
              <Input
                label="Trailer Size"
                name="vehicleDetails.trailerSize"
                errors={errors}
                register={register}
                uppercase={true}
                placeholder="Enter manufacturer year"
                type="text"
              // onBlur={() => trigger("vehicleRegNumber")}

              />
              <Input
                label="chassis Number"
                name="vehicleDetails.chassisNumber"
                errors={errors}
                register={register}
                uppercase={true}
                placeholder="Enter chassis number"
                type="text"
              // onBlur={() => trigger("vehicleRegNumber")}

              />
              <Input
                label="engine Number"
                name="vehicleDetails.engineNumber"
                errors={errors}
                register={register}
                uppercase={true}
                placeholder="Enter engine number"
                type="text"
              // onBlur={() => trigger("vehicleRegNumber")}

              />
              <Input
                label="load Capacity"
                name="vehicleDetails.loadCapacity"
                errors={errors}
                register={register}
                uppercase={true}
                placeholder="Enter load capacity"
                type="text"
              // onBlur={() => trigger("vehicleRegNumber")}

              />
              <Input
                label="Rc Number"
                name="vehicleDetails.rcNumber"
                errors={errors}
                register={register}
                uppercase={true}
                placeholder="Enter rc number"
                type="text"
              // onBlur={() => trigger("vehicleRegNumber")}

              />
              <Input
                label="Body Type"
                name="vehicleDetails.bodyType"
                errors={errors}
                register={register}
                uppercase={true}
                placeholder="Enter body type"
                type="text"
              // onBlur={() => trigger("vehicleRegNumber")}

              />
              <Input
                label="Tires count"
                name="vehicleDetails.tiresCount"
                errors={errors}
                register={register}
                uppercase={true}
                placeholder="Enter tires count"
                type="text"
              // onBlur={() => trigger("vehicleRegNumber")}

              />
              <Input
                label="LivePin Tracking URL"
                name="vehicleDetails.trackingUrl"
                errors={errors}
                register={register}
                placeholder="https://api.livepin.in/api/share-links/..."
                type="url"
              />
              <DatePicker
                label="Insurance Expiry Date"
                onDateChange={(date: string) =>
                  setValue("vehicleDetails.insuranceExpiryDate", new Date(date).toISOString())
                }
                register={register("vehicleDetails.insuranceExpiryDate")}
                name="vehicleDetails.insuranceExpiryDate"
                errors={errors}
                allowPastDates={false}
                includeTime={false}
                disabled={false}
                defaultValue={watch("vehicleDetails.insuranceExpiryDate")}
              />
              {/* <Input
                label="Vehicle Registration Number"
                name="vehicleRegNumber"
                errors={errors}
                register={register}
                uppercase={true}
                placeholder="Enter registration number"
                type="text"
                onBlur={() => trigger("vehicleRegNumber")}
                
              /> */}
            </div>
          </div>
          {/* Tabs for Vehicle Details */}
          <CustomTabs tabs={VehicleTabs} activeTab={activeTab} onTabChange={setActiveTab} />
          <br />
          {activeTab === "Owner Details" && (
            <OwnerDetails
              register={register}
              errors={errors}
              watch={watch}
              setValue={setValue}
              control={control}
              useSameContact={useSameContact}
              setUseSameContact={setUseSameContact}
            />
          )}

          <br />
          {activeTab === "Insurance Details" && (
            <Insurance
              register={register}
              errors={errors}
              setValue={setValue}
              watch={watch}
            />
          )}
          <br />
          {
            activeTab === "Address Details" && <AddressDetails register={register} errors={errors} setValue={setValue} watch={watch} />
          }
          <div className="gap-4 flex items-center justify-end mr-8 self-end mt-4 ">
            <button
              type="button"
              className="w-36 h-10 mr-2 rounded-lg bg-white text-gray-800 border border-gray-300 hover:border-gray-400 transition duration-200"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="w-36 h-10 rounded-lg bg-[#444FBD] text-white transition duration-200"
            >
              Submit
            </button>
          </div>
        </form>
      </AdminContainer>
    </div>
  );
};

export default Managevehicle;
